// Shows loading

import { Spinner } from 'reactstrap'
import PropTypes from 'prop-types'

function Loading ({ color = 'primary', size, className }) {
  return <Spinner color={color} size={size} className={className} />
}

Loading.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string
}

export default Loading
